import React from "react";

import { Link } from "react-router-dom";

import { makeStyles } from "tss-react/mui";
import { Button, Grid } from "@mui/material";

import { OnboardingInfoBox } from "../../components/onboarding/OnboardingInfoBox";

const useStyles = makeStyles()((theme) => ({
  main: {
    backgroundImage: theme.palette.backgrounds.pageGradient,
    height: "100vh",
    padding: theme.spacing(5, 4),
    width: "100vw",
    "& > a": {
      marginTop: theme.spacing(4),
      width: "100%",
    },
  },
}));

const PendingScreen = () => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      className={classes.main}
      alignContent="center"
      justifyContent="center"
    >
      <OnboardingInfoBox
        variant="info"
        title="Estamos carregando os seus dados!"
        body={[
          "Não se preocupe, vamos te notificar assim que a sua plataforma estiver disponível.",
        ]}
      />
      <Button
        component={Link}
        to="/admin/monitoring"
        variant="contained"
        color="primary"
      >
        Conhecer o app da Enermatch
      </Button>
    </Grid>
  );
};

export default PendingScreen;
